import type { AgentApiCompaniesShow } from '@/types/serializers';
import { useQuery } from '@tanstack/react-query';

type Request = {
  id: number;
};

export default function useFetchCompany({ id }: Request) {
  return useQuery({
    queryKey: ['Company', id],
    queryFn: async () => {
      const response = await fetch(`/agent/api/companies/${id}.json`);
      const data: AgentApiCompaniesShow = await response.json();
      return data;
    },
  });
}
